import {i18n} from '@/plugins/i18n'

export const bannerStatusStr = {
    ACTIVE: i18n.t('banner.banner_status.active'),
    INACTIVE: i18n.t('banner.banner_status.inactive'),

    get(status) {
        let str = null;

        Object.keys(bannerStatus).forEach(item => {
            if (bannerStatus[item] === status) {
                str = bannerStatusStr[item];
            }
        });

        return str;
    }
}

export const bannerStatus = {
    ACTIVE: 1,
    INACTIVE: 0
}


export const bannerStatusVariant = (status) => {
    if (status === bannerStatus.ACTIVE) {
        return 'success';
    }

    if (status === bannerStatus.INACTIVE) {
        return 'danger';
    }

    return 'secondary';
};